import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import OpalHeading from '../../../../opal/OpalHeading'
import FlexRow from '../../../../molecules/FlexRow'
import BrandedDocument from '../../../../molecules/BrandedDocument'

function DatasourceGroup ({ groupName, groupItems }) {
  return (
    <div>
      <OpalHeading className='font-size-md'>{groupName}</OpalHeading>
      <FlexRow className='gap-sm flex-wrap'>
        {(groupItems || []).map(item => (
          <Link to={`/admin/denali/catalog/s/${item.catalogDatasourceId}`} key={item.code}>
            <BrandedDocument name={item.displayName} imageUrl={item.imageUrl} />
          </Link>
        ))}
      </FlexRow>
    </div>
  )
}

DatasourceGroup.propTypes = {
  groupName: PropTypes.string,
  groupItems: PropTypes.arrayOf(PropTypes.shape({
    catalogDatasourceId: PropTypes.number,
    code: PropTypes.string,
    displayName: PropTypes.string,
    imageUrl: PropTypes.string,
    namespace: PropTypes.shape({
      displayName: PropTypes.string
    })
  }))
}

export default DatasourceGroup
